var _circle, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _ellipse3, _path13, _path14, _path15, _path16, _rect70, _rect71, _rect72, _path17, _path18, _circle2, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeProgramming = function SvgHomeProgramming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 786.82 572.26"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 458.32,
    cy: 74.18,
    r: 26.7,
    fill: "var(--color-heading, gainsboro)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-heading, gainsboro)",
    d: "M665.45 497.15c39.69-30.23 58.64-81.02 46.77-129.48q-.44-1.8-.93-3.6c-7.87-28.77-27.33-56.1-55.7-65.3-23.82-7.71-49.82-1.78-74.67-4.85-48.78-6.02-86.6-45.5-113.21-86.82-26.61-41.32-47.06-87.58-82.42-121.72C327 29.1 231.93 16.98 159.66 53.62 87.4 90.25 41.36 171.52 43.33 252.52c1.96 80.99 50.04 158.43 119.87 199.51 25.66 15.1 55.32 25.79 84.85 22.05 25.62-3.25 48.9-17.02 74.4-21.1 40.1-6.43 79.93 11.7 114.6 32.82 34.68 21.12 68.17 46.16 107.58 55.95 38.26 9.51 85.66-17.82 120.82-44.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-text-dark, slategray)",
    d: "M608.43 78.32c-.87-.58-1.75-1.13-2.62-1.69A380.24 380.24 0 0 0 525.5 37.7l-6.54 90.22H477.5V24.53c-2.61-.54-5.24-1.05-7.87-1.53v104.92h-49.27A102.27 102.27 0 0 1 318.09 25.65a264.6 264.6 0 0 0-7.88 1.83v100.44h-40.13l-6.23-86.03a380.86 380.86 0 0 0-81.94 43.53l-1.31.91a340.93 340.93 0 0 0-6.56 4.73v344.19H292.3l-2.1-28.95-11.5-158.95h231.6L498.8 406.3l-2.1 28.95h116.97V81.8q-2.61-1.77-5.25-3.48ZM310.2 221.1h-33.4l-6.16-85.3h39.56Zm159.42 0h-56.08v-1.69a6.18 6.18 0 0 0-6.2-6.18h-24.37a6.18 6.18 0 0 0-6.18 6.18v1.69h-58.71v-85.3h151.54Zm7.87 0v-85.3h40.89l-6.17 85.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-text-dark, slategray)",
    d: "M0 434.3a289 289 0 0 0 28.12 28.94l730.58 1a289 289 0 0 0 28.12-28.95Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-stroke-light, silver)",
    d: "M495.43 341.6v85.7a4.12 4.12 0 0 0 4.12 4.11h127a4.12 4.12 0 0 0 4.12-4.11v-85.7a4.12 4.12 0 0 0-4.12-4.12h-127a4.12 4.12 0 0 0-4.12 4.11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-background, black)",
    d: "M498.4 342.66v83.58a2.2 2.2 0 0 0 2.21 2.2H625.5a2.2 2.2 0 0 0 2.2-2.2v-83.58a2.2 2.2 0 0 0-2.2-2.2H500.6a2.2 2.2 0 0 0-2.2 2.2Z",
    opacity: 0.85
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-stroke-light, silver)",
    d: "M492.77 444.01a2.47 2.47 0 0 0 1.95.93H630.7a2.5 2.5 0 0 0 2.45-3.02l-2.12-10.02a2.5 2.5 0 0 0-1.55-1.82 2.42 2.42 0 0 0-.9-.17H496.83a2.42 2.42 0 0 0-.89.17 2.5 2.5 0 0 0-1.56 1.82l-2.1 10.02a2.5 2.5 0 0 0 .5 2.09Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 830.03,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 728.83 514.9)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 821.66,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 720.46 514.9)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 813.28,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 712.08 514.9)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 804.9,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 703.7 514.9)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 796.53,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 695.33 514.9)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 788.15,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 686.95 514.9)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 779.77,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 678.57 514.9)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 771.39,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 670.2 514.9)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 763.02,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 661.82 514.9)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 754.64,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 653.44 514.9)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 746.26,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 645.06 514.9)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 737.89,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 636.69 514.9)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 729.51,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 628.3 514.9)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 721.13,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 619.93 514.9)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 712.76,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 611.56 514.9)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 704.38,
    y: 595.59,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 603.18 514.9)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 830.13,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 728.93 519.1)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 821.76,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 720.56 519.1)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 813.38,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 712.18 519.1)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 805,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 703.8 519.1)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 796.62,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 695.42 519.1)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 788.25,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 687.05 519.1)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 779.87,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 678.67 519.1)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 771.49,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 670.3 519.1)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 763.12,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 661.92 519.1)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 754.74,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 653.54 519.1)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 746.36,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 645.16 519.1)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 737.99,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 636.79 519.1)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 729.61,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 628.4 519.1)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 721.23,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 620.03 519.1)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 712.86,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 611.65 519.1)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19,
    height: 2.51,
    x: 704.48,
    y: 599.78,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 603.28 519.1)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 33.51,
    height: 2.51,
    x: 760.6,
    y: 604.8,
    fill: "var(--color-stroke-dark, dimgray)",
    rx: 0.49,
    transform: "rotate(-180 674.06 524.12)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 515.63,
    y: 358.74,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 548.15,
    y: 358.74,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 557.37,
    y: 358.74,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 3.12,
    x: 524.48,
    y: 358.48,
    fill: "var(--color-accent, lightgray)",
    rx: 1.56
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 3.12,
    x: 567.84,
    y: 358.48,
    fill: "var(--color-accent, lightgray)",
    rx: 1.56
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 524.3,
    y: 365.78,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 556.83,
    y: 365.78,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 566.04,
    y: 365.78,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 3.12,
    x: 533.15,
    y: 365.52,
    fill: "var(--color-accent, lightgray)",
    rx: 1.56
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 3.12,
    x: 576.51,
    y: 365.52,
    fill: "var(--color-accent, lightgray)",
    rx: 1.56
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 532.98,
    y: 372.83,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 565.5,
    y: 372.83,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 574.71,
    y: 372.83,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 3.12,
    x: 541.82,
    y: 372.57,
    fill: "var(--color-accent, lightgray)",
    rx: 1.56
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 3.12,
    x: 585.19,
    y: 372.57,
    fill: "var(--color-accent, lightgray)",
    rx: 1.56
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 541.65,
    y: 379.88,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 574.17,
    y: 379.88,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 583.39,
    y: 379.88,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 3.12,
    x: 550.5,
    y: 379.62,
    fill: "var(--color-accent, lightgray)",
    rx: 1.56
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 548.15,
    y: 407.9,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 557.37,
    y: 407.9,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 3.12,
    x: 567.84,
    y: 408.16,
    fill: "var(--color-accent, lightgray)",
    rx: 1.56
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 515.63,
    y: 407.9,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 3.12,
    x: 524.48,
    y: 408.16,
    fill: "var(--color-accent, lightgray)",
    rx: 1.56
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 524.3,
    y: 400.85,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 556.83,
    y: 400.85,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 566.04,
    y: 400.85,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 3.12,
    x: 533.15,
    y: 401.11,
    fill: "var(--color-accent, lightgray)",
    rx: 1.56
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 532.98,
    y: 393.8,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 565.5,
    y: 393.8,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 574.71,
    y: 393.8,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 3.12,
    x: 541.82,
    y: 394.06,
    fill: "var(--color-accent, lightgray)",
    rx: 1.56
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 541.65,
    y: 386.76,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 574.17,
    y: 386.76,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 5.97,
    height: 3.12,
    x: 583.39,
    y: 386.76,
    fill: "var(--color-fill, lightslategray)",
    rx: 1.56
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 3.12,
    x: 550.5,
    y: 387.02,
    fill: "var(--color-accent, lightgray)",
    rx: 1.56
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8BEAC",
    d: "m504.92 490.48-13.35-21.1 41.9-33.4 17.3-19.16a19.16 19.16 0 0 1 32.41 6.82 19.16 19.16 0 0 1-11.57 24l-27.35 10.07Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-text-light, silver)",
    d: "M191.69 337.48v102.56h71.85V337.48a3.45 3.45 0 0 0-2.43-3.3 3.17 3.17 0 0 0-1.03-.16h-64.92a3.46 3.46 0 0 0-3.47 3.46Zm28.04 35.24a7.67 7.67 0 0 1 15.34 0v11.9a7.67 7.67 0 0 1-15.34 0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-text-light, silver)",
    d: "M78.66 182.96v187.26a9 9 0 0 0 9 9h277.5a9 9 0 0 0 9-9V182.96a9.01 9.01 0 0 0-9-8.99H87.66a9.01 9.01 0 0 0-9 9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-background, black)",
    d: "M85.17 185.3V367.9a4.82 4.82 0 0 0 4.81 4.81h272.87a4.82 4.82 0 0 0 4.81-4.8V185.28a4.82 4.82 0 0 0-4.81-4.82H89.98a4.82 4.82 0 0 0-4.81 4.82Z",
    opacity: 0.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-text-light, silver)",
    d: "M135.81 447.92a2.95 2.95 0 0 0 2.32 1.11h162.34a2.99 2.99 0 0 0 2.92-3.6l-2.52-11.97a3 3 0 0 0-1.86-2.17 2.9 2.9 0 0 0-1.06-.2H140.64a2.9 2.9 0 0 0-1.06.2 3 3 0 0 0-1.86 2.17l-2.52 11.97a2.98 2.98 0 0 0 .61 2.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-stroke, silver)",
    d: "M354 205.63H98.66a1.02 1.02 0 0 1 0-2.03H354a1.02 1.02 0 0 1 0 2.03Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.05,
    cy: 192.33,
    fill: "var(--color-heading, silver)",
    rx: 5.95,
    ry: 6.08
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.61,
    cy: 192.33,
    fill: "var(--color-accent, silver)",
    rx: 5.95,
    ry: 6.08
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.16,
    cy: 192.33,
    fill: "var(--color-fill, silver)",
    rx: 5.95,
    ry: 6.08
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-stroke-light, silver)",
    d: "M341.62 187.75h-14.6a1.1 1.1 0 0 0 0 2.21h14.6a1.1 1.1 0 0 0 0-2.2ZM341.62 191.9h-14.6a1.1 1.1 0 0 0 0 2.21h14.6a1.1 1.1 0 0 0 0-2.2ZM341.62 196.05h-14.6a1.1 1.1 0 0 0 0 2.21h14.6a1.1 1.1 0 0 0 0-2.2Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-fill, darkgray)",
    d: "M693.6 441.1a6.42 6.42 0 0 0 6.18 4.33l26.5-.68a6.33 6.33 0 0 0 5.97-4.66l3.75-40.08a9.8 9.8 0 0 0 4.24.87 9.66 9.66 0 1 0-.49-19.32 8.18 8.18 0 0 0-1.73.18 6.55 6.55 0 0 0-4.88-2.1l-40.75 1.05a5.85 5.85 0 0 0-1 .13 6.36 6.36 0 0 0-4.88 8.26Zm43.17-43.82 2.67-9.55a6.5 6.5 0 0 0 .02-3.37c.13 0 .24-.06.37-.06a6.91 6.91 0 0 1 .32 13.81 6.5 6.5 0 0 1-3.38-.83Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-accent-light, darkslategray)",
    d: "M691.39 380.82c.87 4.96 10.63 8.45 22.36 7.84 10.8-.5 19.62-4.28 21.24-8.78a6.03 6.03 0 0 0-1.85-.24l-40.75 1.05a5.85 5.85 0 0 0-1 .13Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-heading, gainsboro)",
    d: "M715.9 419.07a.5.5 0 0 0 .16-.06l5.75-3.77a.5.5 0 0 0 0-.84l-5.98-3.91a.5.5 0 1 0-.55.83l5.34 3.5-5.11 3.35a.5.5 0 0 0 .4.9ZM706.82 419.5a.5.5 0 0 0 .12-.93l-5.3-3.04 5.13-3.8a.5.5 0 1 0-.6-.8l-5.74 4.26a.5.5 0 0 0 .05.83l5.97 3.42a.5.5 0 0 0 .37.05ZM715.33 422.37a.48.48 0 0 0 .14-.05.5.5 0 0 0 .17-.7l-8.16-13.4a.5.5 0 0 0-.85.52l8.15 13.4a.5.5 0 0 0 .55.23Z"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 50.72,
    height: 10.85,
    x: 209.38,
    y: 260.83,
    fill: "var(--color-heading, gainsboro)",
    rx: 3.26
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 102.24,
    height: 10.85,
    x: 183.63,
    y: 282.52,
    fill: "var(--color-accent, lightgray)",
    rx: 3.26
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 102.24,
    height: 10.85,
    x: 183.63,
    y: 304.21,
    fill: "var(--color-fill, lightslategray)",
    rx: 3.26
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-fill-dark, darkslategray)",
    d: "m290.71 376.85.22.68v.02l6.53 19.84 7.51 22.86 14.12 42.96.14 6.68v.02l1.05 53.68-2.9 7.28 3.26 11.93s-1.5-18.03-9.58-7.67c-4.57 5.88-9.92 11.9-14.31 17.55q9.6 3.89 19.5 7.03c1.43.46 2.87.89 4.3 1.32l.93.28a266.86 266.86 0 0 0 67.35 10.82c1.18.04 2.35.06 3.48.08l1.17.03 3.82.02q3.87 0 7.7-.12a266.85 266.85 0 0 0 56.1-7.58c-.13-7.59-.47-16.45-.96-25.92-.23-4.64-5.35-9.67-5.66-14.53-.22-3.65 4.38-7.09 4.14-10.8-1.55-22.82-3.49-14.06-4.93-30.22q-.22-2.38-.4-4.56c-.93-10.38-1.57-16.87-1.57-16.87l6.14-38.68 9.64-60.74-.75-1.22-.83-.4-50.84-25.17-2.76-7.08a10.98 10.98 0 0 0-10.14-6.94l-33.5-.14a10.93 10.93 0 0 0-8.9 4.53l-9.08 12.56Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-fill-dark, darkslategray)",
    d: "m326.82 453.65-7.59 16.24-5.18 11.09-8.9 46.64-4.47 4.74-3.82-16.76-40 8.88c-1.31-7.3-.35.24-1.16-7.75l.7-.69c.65-.6 1.18-1.15 1.17-1.69-.45-27.58.91-74.52 12.35-102.96a60.05 60.05 0 0 1 7.02-13.1l.66-.93c5.27-7.38 8.6-14.65 13.33-19.82v-.01a.53.53 0 0 0 .08-.08.16.16 0 0 0 .04-.03l32.45-17.2 1.39 39.1 1 28.1ZM443.8 458.26l9.48 20.28 3.3 7.06 8.91 46.64 4.45 4.72 3.83-16.75 1.8-.37 32.46-6.72 9.46 30.04a17.98 17.98 0 0 0-3.26-22.5c-.65-.59-1.19-1.16-1.17-1.7.53-32.44-1.45-91.68-19.37-116.06-5.7-7.74-9.1-15.44-14.08-20.83-.01-.01-.01-.03-.03-.03l-12.09-19.8-.74-1.21-.83-.42Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.4,
    cy: 267.2,
    r: 44.56,
    fill: "#E8BEAC",
    "data-name": "Ellipse 5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-background, black)",
    d: "M446.62 236.08a3.76 3.76 0 0 0-2.69-1.2l.67-1.85a3.53 3.53 0 0 0-3.96-4.7l-2.44.47.23-1.63a3.53 3.53 0 0 0-4.73-3.82 3.77 3.77 0 0 1-3.24-.23 3.85 3.85 0 0 1-1.92-2.61l-.85-4.1-.09-.22c-4.14-6.9-12.1-11.92-21.84-13.76-8.67-1.65-17.56-.81-26.13-.02-3.4.32-7.24.68-10.44 2.64-2.72 1.68-5.02 5.04-4.55 8.43-8.45-2.6-17.5 2.58-22 9.1-5.32 7.76-6.19 17.48-6.33 25.08-.38 17.98 3.33 32.69 11 43.73.56.8.7 2.47 1.81 3.03l-.23-.37c1.24.62 2.5 1.62 2.03 2.69-1.35 3.08 7.62 9.89 13.94 12.14 11.53 4.1 26.86 3.76 37.64 2.28l.38-2.55c3.9-.53 6.63-1.54 7.4-3.12a88.26 88.26 0 0 0 3.53-3.16l.01-.01.08-.07c4.87-4.67 6-7.33 6.51-11.38.5-3.97-.38-8-1.27-11.63 18.74 2.9-7.38-19.96 10.08-24.38a5.43 5.43 0 0 1 .61-.15c.51-.12 1.02-.24 1.51-.38a26.45 26.45 0 0 0 6.72-2.87c4.88-2.97 6.5-6.91 9.01-11.35a3.43 3.43 0 0 0-.45-4.03Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-accent-light, lightgray)",
    d: "M544 461.44c-.02 1.75-.04 4.2-.12 7.23l-.03 1.29a867.56 867.56 0 0 1-.5 16.5c-.29 7.24-.73 15.67-1.49 29.02-1.4 24.66-3.87 3.39-6.34 12.04-.12.43-.25.94-.37 1.54a27.92 27.92 0 0 1-1.88 6.33c-1.3.78-2.66 1.53-3.99 2.28a281 281 0 0 1-18.09 9.23l-1.03.47a270.89 270.89 0 0 1-34.75 13.26c-2.32.7-4.63 1.38-6.97 2-2.44.69-4.88 1.33-7.35 1.93a266.9 266.9 0 0 1-56.09 7.59c-2.55.08-5.12.1-7.7.1l-3.82-.01-1.17-.02-3.48-.08a266.66 266.66 0 0 1-67.35-10.83l-.93-.27c-1.44-.44-2.87-.87-4.3-1.33q-9.9-3.14-19.5-7.02-7.34-2.96-14.5-6.34a.34.34 0 0 1-.13-.06c-1-.46-2-.94-3-1.43l-.42-.21q-5.6-2.73-11.07-5.72c-3.07-7.05-7.39-8.4-10.07-14.6a25.87 25.87 0 0 1-1.68-5.74v-.07c.27 3.72-1.2-6.6-.02-.04l-.03-.4a52 52 0 0 0-.13-1.35c-3.43-33.5-3.2-71.8-4.7-103.35l-.3-5.86-.12-1.83c.07-.18.15-.37.24-.55a1 1 0 0 1 .07-.15 1.62 1.62 0 0 1 .1-.18l.07-.1a.92.92 0 0 1 .05-.1l.3-.43.14-.16a.8.8 0 0 1 .12-.14.64.64 0 0 1 .11-.13l.13-.14a.3.3 0 0 1 .08-.08 2.03 2.03 0 0 1 .26-.25 9.62 9.62 0 0 1 1.14-.9c.14-.1.3-.18.43-.28a19.14 19.14 0 0 1 3.17-1.52l1.17-.41.44-.14.67-.2c1.14-.33 2.37-.62 3.7-.9a16.25 16.25 0 0 1 1.24-.23l1.04-.17c2.97-.47 6.34-.82 10.06-1.05l1.05-.06 1.24-.06 1.07-.04 1.08-.04 3.11-.08c3.02-.06 6.2-.04 9.54.03 1.55.04 3.13.08 4.75.15h.31c1.41.06 2.83.12 4.3.2l3.07.16 2.94.19 2.32.15 1.98.14.9.06 1.48.12 3.32.27 3.37.3c1.13.1 2.27.2 3.41.32.12 0 .23.02.34.03 1.04.1 2.08.2 3.13.32l.73.07 3.03.32.93.1c.8.09 1.58.16 2.37.26 1.05.12 2.12.23 3.16.37a200.76 200.76 0 0 1 6.28.76l1.47.19a869.08 869.08 0 0 1 28.59 4.14q8.8 1.42 17.71 3l4.51.83 2.04.39a424.99 424.99 0 0 1 6.96 1.32l4.15.8a967.5 967.5 0 0 1 26.95 5.74l4.34 1q4.32 1 8.56 2.04l2.32.56c1.92.48 3.84.96 5.73 1.45l.33.09c1.4.34 2.75.69 4.11 1.05q4.82 1.26 9.47 2.55 3.1.85 6.11 1.73a477.7 477.7 0 0 1 10.95 3.29 380.43 380.43 0 0 1 10.88 3.55q2.31.8 4.53 1.59l2.83 1.04 3.98 1.5c.4.15.8.3 1.18.46l.73.3 1.41.56c.47.18.93.37 1.4.57a54.49 54.49 0 0 1 2.67 1.13 102.97 102.97 0 0 1 3.19 1.41c.34.16.68.3 1.02.47l.78.36.33.16.76.37c.58.27 1.15.56 1.71.83a142.19 142.19 0 0 1 4.24 2.26l.32.18.45.25 1.5.88a68.2 68.2 0 0 1 2.71 1.75l.56.38c.63.45 1.23.89 1.8 1.34l.55.44.46.4c.52.45 1 .88 1.44 1.32a5.67 5.67 0 0 1 .42.43 1.2 1.2 0 0 1 .16.16c.2.2.38.4.55.6a.55.55 0 0 1 .07.09c.24.28.46.56.67.84l.3.42.34.52c.1.14.17.29.25.43a7.26 7.26 0 0 1 .54 1.13 5.24 5.24 0 0 1 .27.82 5.84 5.84 0 0 1 .17.8Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M544 461.44c-.02 1.75-.04 4.2-.12 7.23 0 .42-.03.85-.04 1.29a1317.47 1317.47 0 0 1-.5 16.5c-.28 7.24-.72 15.67-1.48 29.02-1.4 24.66-3.87 3.39-6.34 12.04a699.12 699.12 0 0 0-22.42-13.18l-4.39-2.47a1260.4 1260.4 0 0 0-55.02-28.78c-42.95-21.23-89.83-41.88-127.8-55.66a587.65 587.65 0 0 0-20.92-7.17c-13.86-4.43-25.84-7.53-35.06-8.87-9.6-1.4-16.23-.9-18.9 1.99l-.32-5.86-.12-1.83c.06-.17.14-.32.22-.48l.03-.07a1 1 0 0 1 .07-.15 1.62 1.62 0 0 1 .1-.18 1.06 1.06 0 0 1 .12-.2l.3-.43a3.48 3.48 0 0 1 .26-.3.64.64 0 0 1 .11-.13l.13-.14a.3.3 0 0 1 .08-.08 2.03 2.03 0 0 1 .26-.25 9.62 9.62 0 0 1 1.14-.9c.14-.1.3-.18.43-.28a19.14 19.14 0 0 1 3.17-1.52l1.17-.41.44-.14.67-.2a42.78 42.78 0 0 1 4.94-1.12l1.04-.18c2.97-.47 6.34-.82 10.06-1.05l1.05-.06 1.24-.06 1.07-.04 1.08-.04 3.11-.08a255.54 255.54 0 0 1 14.3.19h.3c1.41.05 2.84.12 4.3.19l3.07.16 2.94.19 2.32.15 1.98.14 2.38.18 3.32.27 3.37.3c1.13.1 2.27.2 3.41.32.12 0 .23.02.34.03 1.04.1 2.08.2 3.13.32q8.73.88 17.97 2.07 5.52.7 11.18 1.5a947 947 0 0 1 17.41 2.64q8.8 1.42 17.71 3l4.51.83q2.76.5 5.52 1.04l3.48.67 4.15.8a967.5 967.5 0 0 1 26.95 5.74l4.34 1q4.32 1 8.56 2.04l2.32.57 5.73 1.44.33.09 4.11 1.06q4.82 1.26 9.47 2.54c2.06.58 4.1 1.15 6.11 1.73a705.92 705.92 0 0 1 10.95 3.29q3.15.99 6.18 1.97c1.6.52 3.16 1.05 4.7 1.58q2.31.8 4.53 1.59l2.83 1.03c1.36.5 2.68 1 3.98 1.5l1.18.47a86.64 86.64 0 0 1 3.53 1.43 54.49 54.49 0 0 1 2.68 1.13 102.97 102.97 0 0 1 3.19 1.41c.34.16.68.3 1.02.47l.78.36.33.16a115.03 115.03 0 0 1 7.03 3.64l.45.25 1.5.88a49.67 49.67 0 0 1 5.07 3.47l1.01.84c.52.45 1 .88 1.44 1.32a5.67 5.67 0 0 1 .42.43 1.2 1.2 0 0 1 .16.16l.62.69c.24.28.46.56.67.84l.3.42.34.52c.1.14.17.29.25.43a7.26 7.26 0 0 1 .54 1.13 6.05 6.05 0 0 1 .27.82 5.84 5.84 0 0 1 .17.8Z",
    opacity: 0.2
  })));
};
export default SvgHomeProgramming;